var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    clipPath: "url(#clip0_1_1871)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "s5C4UC"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M26.1937 32.9998C24.0721 32.9668 22.0704 32.4116 20.1167 31.654C15.3919 29.822 11.423 26.9028 8.00196 23.2193C5.51137 20.538 3.33257 17.6286 1.71584 14.3328C0.926844 12.7252 0.306349 11.0516 0.114481 9.26059C-0.133348 6.94677 -0.0214249 4.66048 0.885642 2.47324C1.14946 1.83669 1.51598 1.25824 2.043 0.802078C3.05461 -0.0735518 4.20827 -0.177502 5.43758 0.226682C6.57956 0.602126 7.56411 1.26313 8.51177 1.97794C9.75214 2.9135 10.8203 4.02026 11.7286 5.27806C12.1794 5.90238 12.549 6.56583 12.6757 7.34118C12.7937 8.0621 12.6006 8.69437 12.1425 9.24897C11.9611 9.46849 11.752 9.666 11.546 9.8635C11.332 10.0683 11.1026 10.2567 10.8861 10.4591C9.82901 11.4484 9.65621 12.3638 10.4231 13.5929C11.118 14.7064 11.8559 15.8027 12.6726 16.83C14.5974 19.2515 16.9373 21.2137 19.6032 22.7901C19.7176 22.8573 19.8344 22.9209 19.9513 22.9839C20.7206 23.4003 21.159 23.3624 21.9308 22.7362C22.4541 22.3119 22.9418 21.8429 23.4787 21.4387C23.9171 21.1085 24.406 20.8443 24.8722 20.5502C25.4263 20.2011 25.9637 20.2323 26.5098 20.5851C27.749 21.3855 28.926 22.2691 29.9893 23.2884C30.6879 23.9586 31.3563 24.6654 31.9823 25.4023C32.5579 26.0804 32.9368 26.8765 32.9903 27.7846C33.08 29.3016 32.4239 30.4861 31.2801 31.4271C30.1965 32.3186 28.9075 32.7228 27.5374 32.8989C27.0922 32.9558 26.6408 32.9674 26.1919 32.9998H26.1937Z",
    fill: "#FF7351"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_1871"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 33,
    height: 33,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.c37a48133bf2c49388286d17ca8631aa.svg";
export { ForwardRef as ReactComponent };